import { axios } from '../services/axios';
import {ADD_DEFICIENCY,GET_DEFICIENCY_DATA,UPDATE_DEFICIENCY_DATA,DELETE_DEFICIENCY_DATA,DEFICIENCY_COMPLETE,DEFICIENCY_UPDATE_CORRECTION_DATE,UPLOAD_SIGNATURE,DEFICIENCY_ISSUE_DOCUMENT,GET_CUSTOMER_SIGNATURE } from '../constants/paths';


export type deficiencyDTO = {

    title : String;
    typeof : String;

};

/**
 * defeciency Add  API Call
 * @param {deficiencyDTO} data
 * @returns {Promise<any>}
 */
export const addDeficiencyAPI = (data: deficiencyDTO): Promise<any> => {
    return axios.post(ADD_DEFICIENCY, data);
};




/**
 * get deficiency API Call
 * @returns {Promise<any>}
 */
export const getDeficiencyDataAPI = (params): Promise<any> => {
    return axios.get(`${GET_DEFICIENCY_DATA}`,{params});
};



/**
 * update deficiency API Call
 * @returns {Promise<any>}
 */
export const updateDeficiencyAPI = (id, data): Promise<any> => {
    return axios.patch(`${UPDATE_DEFICIENCY_DATA}/${id}`,data);
};

/**
 * delete deficiency API Call
 * @returns {Promise<any>}
 */
export const deleteDeficiencyApiCall = (id): Promise<any> => {
    return axios.delete(`${DELETE_DEFICIENCY_DATA}/${id}`);
};


/**
 * deficiency CompleteAPI  API Call
 * @returns {Promise<any>}
 */
export const deficiencyCompleteAPI = (data): Promise<any> => {
    return axios.post(`${DEFICIENCY_COMPLETE}`,data);
};

/**
 * deficiency correction date  API Call
 * @returns {Promise<any>}
 */
export const deficiencyCorrectionDate = (data) : Promise<any> => {
    return axios.patch(`${DEFICIENCY_UPDATE_CORRECTION_DATE}`,data);
};


export const uploadSignature =(data) : Promise<any> => {
    return axios.post(`${UPLOAD_SIGNATURE}`,data);
};



/**
 * deficiency correction date  API Call
 * @returns {Promise<any>}
 */
export const deficiencyIssueDocumentAPI = (data) : Promise<any> => {
    return axios.patch(`${DEFICIENCY_ISSUE_DOCUMENT}`,data);
};


// get customer signature

export const getUserSignature = (id) : Promise<any> => {
    return axios.get(`${GET_CUSTOMER_SIGNATURE}/${id}`);
};